import axios from '../utils/request';

// 获取公告列表
export function getAnnounceList(params) {
  return axios({
    url: '/announce/list',
    type: 'get',
    params
  })
}

// 新增公告
export function addAnnounce(params) {
  return axios({
    url: '/announce/add',
    type: 'post',
    params
  })
}

// 修改公告
export function updateAnnounce(params) {
  return axios({
    url: '/announce/update',
    type: 'post',
    params
  })
}

// 删除公告
export function deleteAnnounce(params) {
  return axios({
    url: '/announce/del',
    type: 'delete',
    params
  })
}



// 获取跑马灯列表
export function getMarqueeList(params) {
  return axios({
    url: '/module/conf/marquee',
    type: 'get',
    params
  })
}

// 新增跑马灯
export function addMarquee(params) {
  return axios({
    url: '/module/conf/marquee/add',
    type: 'post',
    params
  })
}

// 修改跑马灯
export function updateMarquee(params) {
  return axios({
    url: '/module/conf/marquee',
    type: 'post',
    params
  })
}
// 删除跑马灯
export function delMarquee(params) {
  return axios({
    url: '/module/conf/marquee/del',
    type: 'post',
    params
  })
}